// npm imports
import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import { withRouter } from "react-router-dom";
import { Loader, Toastr } from "@revvsales/components";

// Components Imports
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Modal from "react-responsive-modal";
import SelectTemplateList from "./SelectTemplateList";
import AssetUploadTemplate from "./AssetUploadTemplate";

// Actions Imports
import { DocumentTemplateActions } from "../../../../actions";
import {
  createDocumentAndContent,
  saveDocument,
} from "../../../../actions/DocumentActions";

// Services Imports
import {
  deleteDocumentComponentService,
  batchUpdateDocumentSection,
} from "../../../../actions/DocumentActions/services";

// Internal Imports
import { GlobalUtils, DocumentUtils, AmplitudeUtils } from "../../../../utils";
import CreateDocumentNotes from "../../../RevvEditor/createDocumentNotes";
import { PATHS, EVENTS } from "../../../../constants";

// Destructuring
const { getTemplateInitData } = DocumentTemplateActions;
const { handleApiErrMsg, writeDataToLocalStorage } = GlobalUtils;
const { replaceClauseAndDynamicFields } = DocumentUtils;

// const QUOTE_TYPE_NAME = "Quote/Order Form";
const EDITOR_TEMPLATE_TYPE = "editor";
const { amplitudeLogEvent } = AmplitudeUtils;

// Component
class AssetCreateDocumentPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      documentIsLoading: false,
      showTemplateSelection: true,
      docURI: null,
      turnAroundDate: moment()
        .add(7, "days")
        .format(),
      errMsg: "",
      loadMoreTemplates: false,
    };
    this.popupRef = React.createRef();
  }

  componentDidMount() {
    this.toggleLoading(true);
    this.props
      .getTemplateInitData()
      .then(response => {
        if (response && response.length === 0) {
          this.setState({ showTemplateSelection: false });
        }
        this.toggleLoading(false);
      })
      .catch(() => {
        this.toggleLoading(false);
      });
    // pagination for templates in popup
    const modalScrollElement = document.querySelectorAll(
      ".styles_overlay__CLSq- .assetcreatedoc-block.templates .select-template-list-wrapper",
    );
    if (modalScrollElement && modalScrollElement.length) {
      modalScrollElement[0].addEventListener("scroll", this._loadMoreTemplates);
    }
  }

  componentWillUnmount() {
    const modalScrollElement = document.querySelectorAll(
      ".styles_overlay__CLSq- .assetcreatedoc-block.templates .select-template-list-wrapper",
    );
    if (modalScrollElement && modalScrollElement.length) {
      modalScrollElement[0].removeEventListener(
        "scroll",
        this._loadMoreTemplates,
      );
    }
  }

  _loadMoreTemplates = () => {
    const modalScrollElement = document.querySelectorAll(
      ".styles_overlay__CLSq- .assetcreatedoc-block.templates .select-template-list-wrapper",
    );
    if (modalScrollElement && modalScrollElement.length) {
      if (
        modalScrollElement[0].scrollTop + modalScrollElement[0].clientHeight >=
        modalScrollElement[0].scrollHeight
      ) {
        const { hasMore, pageNum } = this.props;
        const { loadMoreTemplates } = this.state;
        if (hasMore && !loadMoreTemplates) {
          this.setState({ loadMoreTemplates: true });
          this.props
            .getTemplateInitData(pageNum + 1, true)
            .then(() => {
              this.setState({ loadMoreTemplates: false });
            })
            .catch(() => {
              this.setState({ loadMoreTemplates: false });
            });
        }
      }
    }
  };

  toggleLoading = isLoading => {
    this.setState({ loading: isLoading });
  };

  setDocUri = uri => {
    this.setState({ docURI: uri });
  };

  setErrMsg = msg => {
    this.setState({ errMsg: msg });
  };

  setDoc = docDetails => {
    this.toggleLoading(true);
    // const { name: opportunityName } = this.props.opportunity;
    const opportunityName = "NewAssetDoc";
    const { fileDetails, error } = docDetails;
    if (error) {
      this.setState({ errMsg: error, loading: false });
    } else {
      // No oppurtunity: setting default change later
      saveDocument(fileDetails, opportunityName).then(uri => {
        if (typeof uri === "string") {
          this.setState({ docURI: uri, errMsg: "" });
          this.createDoc();
        } else {
          this.setState({
            docURI: undefined,
            errMsg: "Invalid content in the uploaded docx file",
          });
        }
      });
    }
  };

  // post doc create actions : handle routing
  _postDocCreationAction = (docNo, revisionNo) => {
    this.toggleLoading(false);
    // this.setState({ showBtnLoader: false });
    writeDataToLocalStorage("documentPageSource", this.props.source);
    this.props.history.push(`${PATHS.DOCUMENTS_PATH}/${docNo}`);
    console.debug("for amplitude", revisionNo);
  };

  _saveDoc = document => {
    // this.toggleLoading(true);
    createDocumentAndContent(document)
      .then(details => {
        const {
          id,
          components: docComponents,
          doc_no: docNo,
          fields_used: fieldsUsed,
          template_id: templateID,
          template_type: templateType,
          document_status: documentStatus,
          document_tag: documentTag,
        } = details.Document;
        amplitudeLogEvent(EVENTS.EVENT_NAMES.DOCUMENT_CREATED, {
          initiatedFrom: this.props.source,
          status: documentStatus && documentStatus.name,
          tag: documentTag && documentTag.name,
          DocumentID: id,
          templateID,
        });
        const components = docComponents || [];
        if (!templateID) {
          const commentSection =
            components &&
            components.find(
              section => section.content.section_type === "Comments",
            );
          if (commentSection) {
            const notes = new CreateDocumentNotes({
              id,
              components,
              mode: "DOCUMENT",
            });
            notes.create();
            deleteDocumentComponentService(docNo, commentSection);
          }
          this._postDocCreationAction(docNo, details.revision_no);
        } else if (templateID && templateType === EDITOR_TEMPLATE_TYPE) {
          const updatedComponents = replaceClauseAndDynamicFields(
            components,
            fieldsUsed,
          );
          batchUpdateDocumentSection(updatedComponents, [], id)
            .then(() => {
              this._postDocCreationAction(docNo, details.revision_no);
            })
            .catch(err => {
              // this.toggleLoading(false);
              Toastr.showToastr({
                type: "failure",
                message: handleApiErrMsg(err),
                timeout: 3000,
              });
              this.setState({ documentIsLoading: false });
              console.error(err);
            });
        } else {
          this._postDocCreationAction(docNo, details.revision_no);
        }
      })
      .catch(error => {
        console.error(`CreateQuotePopup => _createDocument => ${error}`);
        // this.toggleLoading(false);
        // this.setState({ showBtnLoader: false });
        Toastr.showToastr({
          type: "failure",
          message: handleApiErrMsg(error),
          timeout: 3000,
        });
        this.setState({ documentIsLoading: false });
      });
  };

  createDoc = template => {
    this.setState({ documentIsLoading: true });
    const defStatus = this.props.assetStatusList[0];
    const { turnAroundDate, docURI } = this.state;
    const { extQuoteId } = this.props;
    const doc = {
      deadline_date: turnAroundDate,
      doc_no: "",
      meta_values: {},
      meta_data: template ? template.meta_data : {},
      template_id: template ? template.id : null,
      title: "",
      uri: docURI,
      created_from: template ? "template" : "blank/upload",
      folder_id: this.props.currentFolderID || null,
      document_status: defStatus || null,
      document_tag: null,
      quote_ids: extQuoteId ? [extQuoteId] : [],
    };
    this._saveDoc(doc);
  };

  render() {
    const {
      loading,
      showTemplateSelection,
      documentIsLoading,
      errMsg,
    } = this.state;
    const { documentTemplates, isOpen, togglePopup } = this.props;
    let errSpace = null;
    if (errMsg) {
      errSpace = (
        <div className="error-message-wrapper">
          <span className="error-message-icon">
            <FontAwesomeIcon icon={["far", "times-circle"]} />
          </span>
          {this.state.errMsg}
        </div>
      );
    }
    return (
      <Modal
        open={isOpen}
        onClose={() => togglePopup()}
        center="true"
        classNames={{
          modal: "assetcreatedoc-popup",
        }}
        closeOnOverlayClick={false}>
        {documentIsLoading && (
          <Loader className="loader-bg-color" label="Creating Document..." />
        )}
        <div className="assetcreatedoc-popup-container">
          {showTemplateSelection && (
            <div className="assetcreatedoc-block templates">
              <div className="assetcreatedoc-popup-heading">
                Select a document template to get started and request
                eSignatures or collect payments via Stripe
              </div>
              <SelectTemplateList
                templates={documentTemplates}
                loading={loading}
                createDoc={this.createDoc}
              />
            </div>
          )}
          <div className="assetcreatedoc-block or">
            <span>or</span>
          </div>
          <div className="assetcreatedoc-block upload">
            <div className="assetcreatedoc-popup-heading">
              Upload your own document and request eSignatures or collect
              payments via Stripe
            </div>
            {errSpace}
            <div className="assetcreatedoc-popup-body">
              <AssetUploadTemplate
                templates={documentTemplates}
                loading={loading}
                createDoc={this.createDoc}
                setErrMsg={this.setErrMsg}
                setDocUri={this.setDocUri}
                setDoc={this.setDoc}
              />
            </div>
          </div>
        </div>
        {/* <div>
          {!loading && showTemplateSelection && (
            <div
              className="assetcreatedoc-custom-doc-ico"
              onClick={() => this.toggleTemplateSelection()}
              onKeyPress={() => {}}
              role="button"
              tabIndex="0">
              <i>
                <FontAwesomeIcon icon={["far", "plus"]} />
              </i>
              <span>Make your own document</span>
            </div>
          )}
        </div> */}
      </Modal>
    );
  }
}

const mapStateToProps = ({
  TemplateStore: {
    documentTemplates,
    documentTemplatesInfo: { pageNum, hasMore },
  },
  AssetStore: { currentFolderID, assetStatusList, assetTagsList },
}) => ({
  documentTemplates,
  currentFolderID,
  assetStatusList,
  assetTagsList,
  pageNum,
  hasMore,
});

const mapDispatchToProps = {
  getTemplateInitData,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(AssetCreateDocumentPopup));



// WEBPACK FOOTER //
// ./src/components/AssetWrapper/AssetHeader/AssetCreateDocumentPopup/index.js